import React, { ComponentProps, createContext, FC, useContext, useMemo } from 'react';
import { NikeRoute } from './types';

const NikeRouteContext = createContext<{
    activeRoute: NikeRoute;
    routeParams?: Record<string, string>;
}>({
    activeRoute: null,
    routeParams: {}
});

export const useActiveRoute = () => useContext(NikeRouteContext).activeRoute;
export const useNikeRouteParamsContext = () => useContext(NikeRouteContext).routeParams;
export const useNikeRouteContext = () => useContext(NikeRouteContext);

export const NikeRouteContextProvider: FC<ComponentProps<typeof NikeRouteContext.Provider>['value']> = ({
    activeRoute,
    routeParams,
    children
}) => {
    const contextValue = useMemo(() => {
        return { activeRoute, routeParams };
    }, [activeRoute, routeParams]);

    return <NikeRouteContext.Provider value={contextValue}>{children}</NikeRouteContext.Provider>;
};
